module.exports = __webpack_public_path__ + "img/Vorschau_2180x840_03.b85bb4a3.jpg";